/* eslint-disable @typescript-eslint/no-unused-vars */
import { BaseLoginProvider, SocialUser } from '@abacritt/angularx-social-login';
import { Injectable } from '@angular/core';

/**
 * Custom provider for Apple login so we can use a similar approach for other social providers.
 * The base login provider requires these methods - for our current use case we are currently
 * not interested in the results, so are effectively crippling the methods.
 */
@Injectable({ providedIn: 'root' })
export class AppleLoginProvider extends BaseLoginProvider {
  public static readonly PROVIDER_ID = 'APPLE' as const;

  constructor() {
    super();
  }

  /** Required params to extend the base provider - un-required for our implementation */
  initialize(autoLogin?: boolean | undefined): Promise<void> {
    return new Promise((resolve) => resolve());
  }

  /** Get the current login status */
  getLoginStatus(): Promise<SocialUser> {
    return new Promise((resolve) => resolve({} as SocialUser));
  }

  /** Sign a user in */
  signIn(signInOptions?: object | undefined): Promise<SocialUser> {
    return new Promise((resolve) => resolve({} as SocialUser));
  }

  /** Sign a user out */
  signOut(revoke?: boolean | undefined): Promise<void> {
    return new Promise((resolve) => resolve());
  }
}
